import React, { useState, useEffect } from 'react';
import { Controller, useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useParams } from 'react-router-dom';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import { useTranslation } from 'react-i18next';
import { Product } from 'features/Products/productsTypes';
import {
  fetchOrderListDetails,
  getOrderListDetails,
  getOrdersListDetailsLoaders,
  saveOrderList,
  resetDetails
} from 'features/OrdersList/ordersListForm';
import { Row } from 'components/UI/Row';
import { BottomActionBar } from 'components/UI/BottomActionBar';
import { ButtonLoader } from 'components/Loaders/ButtonLoader';
import { Skeleton } from '@material-ui/lab';
import { SelectableProducts } from './components/SelectableProducts';
import { SelectableSerialNumbers } from './components/SelectableSerialNumbers';

interface LinkToOrderListProps {}

interface LinkOrderListForm {
  name: string;
  orderListId: string;
}

const LinkToOrderList = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const history = useHistory();
  const { orderListId } = useParams<{ orderListId?: string }>();
  const orderList = useSelector(getOrderListDetails);
  const { customerId } = useParams<{ customerId: string }>();
  const { isLoading, isSaving } = useSelector(getOrdersListDetailsLoaders);
  const [selectedProduct, setSelectedProduct] = useState<null | Product>(null);
  const [productsInOrderlist, setProductsInOrderlist] = useState<string[]>([]);
  const [selectedSerialNumbers, setSelectedSerialNumbers] = useState<string[]>([]);

  const { handleSubmit, control, setValue } = useForm<LinkOrderListForm>({
    mode: 'onBlur'
  });

  useEffect(() => {
    if (orderListId) {
      dispatch(fetchOrderListDetails(orderListId));
    }
    return () => {
      dispatch(resetDetails());
    };
  }, []);

  useEffect(() => {
    if (orderList) {
      const { short_name, products } = orderList;
      setValue('name', short_name);
      const sns: string[] = [];
      const pids: string[] = [];
      products.map((p: any) => {
        p.serial_number.map((sn: any) => sns.push(sn.value));
        pids.push(p.id);
      });

      setSelectedSerialNumbers(sns);
      setProductsInOrderlist(pids);
    }
  }, [orderList, setValue]);

  const onSubmit = async (formData: LinkOrderListForm) => {
    dispatch(
      saveOrderList({
        history,
        id: orderList?.id,
        orderList: {
          customer_id: customerId,
          serial_numbers: selectedSerialNumbers,
          short_name: formData.name
        }
      })
    );
  };

  return (
    <>
      <form onSubmit={handleSubmit(onSubmit)} noValidate style={{ paddingBottom: '60px' }}>
        {isLoading ? (
          <Skeleton variant="text" animation="wave" width="100%" height="80px" />
        ) : (
          <Controller
            as={
              <TextField
                fullWidth
                autoComplete="new-password"
                /* helperText={t(get(errors, 'name.message'))}
                error={!isEmpty(get(errors, `name`))} */
                label={t('label.name')}
                style={{ margin: '16px 0' }}
                variant="outlined"
              />
            }
            control={control}
            defaultValue=""
            name="name"
          />
        )}
        <SelectableProducts
          selectedProduct={selectedProduct}
          setSelectedProduct={setSelectedProduct}
          productsInOrderlist={productsInOrderlist}
        />
        {selectedProduct && (
          <SelectableSerialNumbers
            product={selectedProduct}
            selectedSerialNumbers={selectedSerialNumbers}
            setSelectedSerialNumbers={setSelectedSerialNumbers}
          />
        )}
        <BottomActionBar>
          <Row padding="20px" justifyContent="flex-end">
            <Button type="submit" color="primary" disabled={isLoading || isSaving} variant="contained">
              {t('label.save')}
              <ButtonLoader show={isSaving} />
            </Button>
          </Row>
        </BottomActionBar>
      </form>
    </>
  );
};

export { LinkToOrderList };
